<template>
  <div class="ren-decoration-cp ren-decoration-cp-coupon-strip" :style="cardStyle">
    <div>
      <strong>{{ title }}</strong>
      <span>{{ subtitle }}</span>
    </div>
    <i :style="buttonStyle">{{ buttonText }}</i>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const title = computed(() => stringValue(props.component.props?.title, '会员专享券'))
const subtitle = computed(() => stringValue(props.component.props?.subtitle))
const buttonText = computed(() => stringValue(props.component.props?.buttonText, '去领取'))
const cardStyle = computed(() => {
  const color = stringValue(props.component.style?.cardColor)
  return color ? { backgroundColor: color } : undefined
})
const buttonStyle = computed(() => ({
  backgroundColor: props.themeTokens?.primaryColor || props.themeColor || 'var(--ren-theme-primary)'
}))
</script>
